import { render, staticRenderFns } from "./LandingComoColsItem.vue?vue&type=template&id=4b51f624&scoped=true"
import script from "./LandingComoColsItem.vue?vue&type=script&lang=js"
export * from "./LandingComoColsItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b51f624",
  null
  
)

export default component.exports